// extracted by mini-css-extract-plugin
export default {"title":"schedule_title__PQcBK","subTitle":"schedule_subTitle__GnSiD","table":"schedule_table__FkbFA","contentBlock":"schedule_contentBlock__pRbdz","noWrap":"schedule_noWrap__qoSbb"};